<template>
    <footer class="footer position-absolute bottom-0 w-100 text-center text-white ">
        <p class="my-2">Powered by TAC ECONOMICS for Veolia Risk Department - Property of Veolia©</p>
    </footer>
</template>

  